import type { PipelineStage } from '../api'

const PRIMARY_IMAGES = ['tenant-api', 'central-api', 'ops-api']

function shortTag(tag: string): string {
    const match = tag.match(/sha-([0-9a-f]{8})/)
    return match ? match[1]! : tag.slice(0, 8)
}

function tagColorClass(tag: string, prevTag: string | undefined): string {
    if (!prevTag) return 'bg-slate-700 text-slate-300'
    if (tag === prevTag) return 'bg-emerald-900/40 text-emerald-400 ring-1 ring-emerald-700/50'
    return 'bg-amber-900/40 text-amber-400 ring-1 ring-amber-700/50'
}

interface StageCardProps {
    stage: PipelineStage
    prevStage: PipelineStage | undefined
    isPromoting: boolean
    animateIn: boolean
}

export function StageCard({ stage, prevStage, isPromoting, animateIn }: StageCardProps) {
    const isFirst = !prevStage

    return (
        <div
            className={[
                'flex flex-col gap-3 rounded-xl border bg-slate-800/60 p-5 shadow-sm w-44 shrink-0 transition-all duration-300',
                isPromoting ? 'animate-pulse-ring border-indigo-500/50' : 'border-slate-700',
                animateIn ? 'animate-slide-in' : '',
            ].join(' ')}
        >
            <div className="flex flex-col gap-0.5">
                <span className="text-xs font-semibold uppercase tracking-widest text-slate-500">
                    {isFirst ? 'CI' : 'Ring'}
                </span>
                <span className="text-lg font-bold text-white leading-none">
                    {stage.displayName}
                </span>
            </div>

            <div className="flex flex-col gap-1.5">
                {PRIMARY_IMAGES.map(img => {
                    const tag = stage.tags[img]
                    const prevTag = prevStage?.tags[img]
                    if (!tag) return null
                    return (
                        <div key={img} className="flex flex-col gap-0.5">
                            <span className="text-[10px] text-slate-500 font-mono leading-none">
                                {img.replace('-api', '')}
                            </span>
                            <span
                                className={`inline-block rounded-md px-2 py-0.5 font-mono text-xs font-semibold ${tagColorClass(tag, prevTag)}`}
                                title={tag}
                            >
                                {shortTag(tag)}
                            </span>
                        </div>
                    )
                })}
            </div>

        </div>
    )
}
